<script>
import { Picture, User, ChatDotRound, Document, Star, Setting, Share, Collection } from '@element-plus/icons-vue'
import { promptWechatFirstVisit, loginPageRoute } from '@/utils/loginFlow'
import appImage from '@/assets/app.png'
import axios from 'axios'
import {
  saveHomeScrollPosition,
  restoreHomeScrollPosition,
  shouldRestoreHomeScroll
} from '@/utils/homeScroll'

export default {
  name: 'HomeView',
  components: {
    Picture,
    User,
    ChatDotRound,
    Document,
    Star,
    Setting,
    Share,
    Collection
  },
  data() {
    return {
      appImage: appImage,
      carouselItems: [],
      carouselLoading: false,
      comments: [
        {
          id: 1,
          name: '张心雨',
          avatar: '/api/v1/static/images/user/g1.webp',
          comment: '很棒的平台！在这里遇到了很多有趣的人。',
          rating: 5
        },
        {
          id: 2,
          name: '李倩倩',
          avatar: '/api/v1/static/images/user/g3.webp',
          comment: '社区非常支持且友好。',
          rating: 4
        },
        {
          id: 3,
          name: '王静雯',
          avatar: '/api/v1/static/images/user/g5.webp',
          comment: '分享经验和学习的最佳场所。',
          rating: 5
        },
        {
          id: 4,
          name: '赵东东',
          avatar: '/api/v1/static/images/user/b2.webp',
          comment: '功能强大且界面易用。',
          rating: 5
        }
      ],
      newsItems: [],
      newsLoading: false,
      features: [
        { icon: 'User', name: '个人中心' },
        { icon: 'ChatDotRound', name: '消息' },
        { icon: 'Document', name: '编辑推荐' },
        { icon: 'Star', name: '收藏' },
        { icon: 'Setting', name: '设置' },
        { icon: 'Share', name: '分享' }
      ]
    }
  },
  async created() {
    const result = await promptWechatFirstVisit()
    if (result === 'navigate') {
      this.$router.push(loginPageRoute('/'))
      return
    }
    this.initHomePage()
  },
  activated() {
    this.tryRestoreHomeScroll()
  },
  methods: {
    async initHomePage() {
      await Promise.all([this.fetchCarouselItems(), this.fetchNewsItems()])
      await this.tryRestoreHomeScroll()
    },
    async tryRestoreHomeScroll() {
      if (!shouldRestoreHomeScroll()) return
      await this.$nextTick()
      await restoreHomeScrollPosition()
    },
    onNewsNavigate() {
      saveHomeScrollPosition()
    },
    formatNewsDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(Number(timestamp) * 1000)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },
    async fetchNewsItems() {
      this.newsLoading = true
      try {
        const response = await axios.get('/api/v1/home/news/list')
        if (response.data?.code === 200 && response.data.data?.items) {
          this.newsItems = response.data.data.items
        }
      } catch (error) {
        console.error('获取最新动态失败:', error)
      } finally {
        this.newsLoading = false
      }
    },
    async fetchCarouselItems() {
      this.carouselLoading = true
      try {
        const response = await axios.get('/api/v1/home/carousel/list')
        if (response.data?.code === 200 && response.data.data?.items) {
          this.carouselItems = response.data.data.items.map((item) => ({
            id: item.id,
            image: item.imageUrl,
            title: item.mainTitle,
            description: item.subtitle
          }))
        }
      } catch (error) {
        console.error('获取主页轮播图失败:', error)
      } finally {
        this.carouselLoading = false
      }
    },
    goToDownloadApp() {
      this.$router.push('/download-app')
    }
  }
}
</script>

<template>
  <div v-loading="carouselLoading" class="home-carousel-div">
    <el-carousel
      v-if="carouselItems.length"
      :interval="4000"
      height="500px"
      class="home-carousel"
      indicator-position="outside"
    >
      <el-carousel-item v-for="item in carouselItems" :key="item.id">
        <el-image 
          :src="item.image" 
          fit="cover"
          class="carousel-image"
        >
          <template #error>
            <div class="image-slot">
              <el-icon><Picture /></el-icon>
            </div>
          </template>
        </el-image>
        <div class="carousel-content">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    
    <!-- APP图片叠放在轮播图右侧 -->
    <div class="app-overlay" @click="goToDownloadApp">
      <el-image 
        :src="appImage" 
        fit="cover"
        class="app-image"
      >
        <template #error>
          <div class="image-slot">
            <el-icon><Picture /></el-icon>
          </div>
        </template>
      </el-image>
    </div>
  </div>
  <div class="home">


   

    <div v-loading="newsLoading" class="blogs-section">
      <h2>最新动态</h2>
      <div v-if="newsItems.length" class="blogs-grid">
        <router-link
          v-for="item in newsItems"
          :key="item.id"
          :to="`/home/news/${item.id}`"
          class="blog-card blog-card--clickable"
          @click="onNewsNavigate"
        >
          <el-image :src="item.imageUrl" fit="cover" class="blog-image">
            <template #error>
              <div class="image-slot">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
          <div class="blog-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.excerpt }}</p>
            <div class="blog-footer">
              <span class="date">{{ formatNewsDate(item.createdAt) }}</span>
              <span class="read-more">查看详情 →</span>
            </div>
          </div>
        </router-link>
      </div>
      <el-empty v-else-if="!newsLoading" description="暂无动态" />
    </div>




    
    <div class="comments-section">
      <h2>用户心声</h2>
      <div class="comments-grid">
        <div v-for="comment in comments" :key="comment.id" class="comment-card">
          <el-avatar :size="60" :src="comment.avatar" />
          <h3>{{ comment.name }}</h3>
          <p>{{ comment.comment }}</p>
          <div class="rating">
            <el-rate v-model="comment.rating" disabled />
          </div>
        </div>
      </div>
    </div>

    <div class="features-section">
      <h2>功能介绍</h2>
      <div class="features-grid">
        <div v-for="(feature, index) in features" :key="index" class="feature-item">
          <el-icon class="feature-icon">
            <component :is="feature.icon" />
          </el-icon>
          <span>{{ feature.name }}</span>
        </div>
      </div>
    </div>

    <template v-if="$root.isLoggedIn">
      
      <div class="user-content">
        <p>您已登录，可以访问所有功能。</p>
        <!-- <div class="quick-actions">
            <button @click="$router.push('/moment')">查看社区动态</button>
        </div> -->
      </div>
    </template>
    <template v-else>
       
      <div class="guest-content">
        <p>Please log in to access all features.</p>
        <button @click="$goToLogin($route.fullPath)">Login Now</button>
        
       </div>
    </template>
  </div>
</template>

<style scoped>
.home {
  padding: 0px;
  max-width: 1800px;
  margin: 0 auto;
   
}

.home-carousel {
  margin-bottom: 40px;
  width: 100%;
  position: relative;
}

/* APP图片叠放区域（手机示意）；暂不展示  */
.app-overlay {
  display: none;
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  width: 36.46vh; /* 70vh / 1.92 ≈ 36.46vh */
  height: 70vh; /* 占屏幕高度的70% */
  border-radius: 15px;
  overflow: hidden;
  background: transparent;
}

.app-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.app-overlay {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.app-overlay:hover {
  transform: scale(1.05);
}

.app-overlay:hover .app-image {
  transform: scale(1.05);
}

.carousel-image {
  width: 100%;
  height: 100%;
}

.carousel-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px;
  padding-right: 140px;
  padding-bottom: 140px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: white;
  text-align: right;
}

.carousel-content h3 {
  font-size: 48px;
  margin-bottom: 16px;
  color: white;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.carousel-content p {
  font-size: 20px;
  color: rgba(255,255,255,0.95);
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.5;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}

.user-content, .guest-content {
  max-width: 1800px;
  margin: 40px auto;
  padding: 30px;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.quick-actions {
  margin-top: 20px;
}

button {
  padding: 10px 20px;
  background-color: var(--el-color-primary);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  transition: all 0.3s;
}

button:hover {
  background-color: var(--el-color-primary-light-3);
}

h2 {
  color: var(--el-text-color-primary);
  margin-bottom: 20px;
  font-size: 24px;
}

h3 {
  color: var(--el-text-color-primary);
  margin-bottom: 15px;
  font-size: 18px;
}

p {
  color: var(--el-text-color-regular);
  line-height: 1.6;
}

.comments-section, .blogs-section, .features-section {
  margin: 40px auto;
  max-width: 1800px;
  padding: 0 20px;
}

.comments-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.comment-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.comment-card h3 {
  margin: 10px 0;
}

.rating {
  margin-top: 10px;
}

.blogs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.blog-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.blog-card--clickable {
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.blog-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.blog-image {
  width: 100%;
  height: 200px;
}

.blog-content {
  padding: 10px;
}

.blog-content h3 {
  margin-bottom: 10px;
}

.blog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.date {
  color: var(--el-text-color-secondary);
  font-size: 14px;
}

.read-more {
  color: var(--el-color-primary);
  font-size: 14px;
  flex-shrink: 0;
}

.blog-card--clickable:hover .read-more {
  text-decoration: underline;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 32px;
  margin-bottom: 10px;
  color: var(--el-color-primary);
}

@media (max-width: 1024px) {
  .comments-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .blogs-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .comments-grid,
  .blogs-grid,
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  /* 移动端APP图片调整 */
  .app-overlay {
    width: 26.04vh; /* 50vh / 1.92 ≈ 26.04vh */
    height: 50vh; /* 移动端使用50%屏幕高度 */
    top: 15px;
    left: 15px;
  }
}

@media (max-width: 480px) {
  .app-overlay {
    width: 20.83vh; /* 40vh / 1.92 ≈ 20.83vh */
    height: 40vh; /* 小屏幕使用40%屏幕高度 */
    top: 10px;
    left: 10px;
  }
}
</style>